import React, { useCallback, useEffect } from "react";
import "./SharedTexts.scss";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { NoTextsMessage } from "./NoTextsMessage/NoTextsMessage";
import { SharedTextsList } from "./SharedTextsList/SharedTextsList";
import TableLoading from "../../components/TableLoading/TableLoading";
import { getService } from "../../services/axios/services";
import { groupAttachmentsByProject } from "./sharedTexts.utils";

export function SharedTexts() {
  const [isLoading, setIsLoading] = React.useState(true);
  const [sharedTexts, setSharedTexts] = React.useState(null);

  const getSharedWithMeAttachments = useCallback(() => {
    getService({ endpoint: `Sharing/attachments/me` })
      .then((response) => {
        const groupedByProjects = groupAttachmentsByProject(response);
        const orderedByLastSharedAt = orderByLastSharedAt(groupedByProjects);
        setSharedTexts(orderedByLastSharedAt);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, []);

  function orderByLastSharedAt(items) {
    return [...items].sort((a, b) => {
      const dateA = new Date(a.lastSharedAt).getTime();
      const dateB = new Date(b.lastSharedAt).getTime();
      return dateB - dateA;
    });
  }

  useEffect(() => {
    getSharedWithMeAttachments();
  }, [getSharedWithMeAttachments]);

  return (
    <div id="shared-texts">
      <Breadcrumb maxWidth="1800px">
        <h2>Textos Compartilhados</h2>
      </Breadcrumb>

      <div className="shared-texts-content">
        {!!sharedTexts && !!sharedTexts?.length && (
          <SharedTextsList sharedTexts={sharedTexts} />
        )}

        {!isLoading && !sharedTexts?.length && <NoTextsMessage />}

        {isLoading && <TableLoading />}
      </div>
    </div>
  );
}
